/* eslint-disable no-unused-expressions */
import { getTransactionId } from '../../common/data';
import { store } from '../../redux';
import { quoteSelectors } from '../../redux/features/quote.slice';
import { axiosWithToken, callFesWithLoading } from '../index';

const { REACT_APP_API_GATEWAY, REACT_APP_BACKEND_BRAND } = process.env;

export const sendEmail = (): Promise<any> => {
  return callFesWithLoading.postMiles(`mail-service/${getTransactionId()}/send-snc-email`);
};

export const creditScoringStart = (data?: any): Promise<any> => {
  const quoteId = quoteSelectors.selectQuoteId(store.getState());
  const url = `${REACT_APP_API_GATEWAY}/miles/${REACT_APP_BACKEND_BRAND}/quotes/${quoteId}/credit-applications/start`;
  return axiosWithToken.post(url, data);
};
